import { TransparenciaInformacaoAdicionalGrupo } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';

export class TransparenciaInformacaoAdicionalItem extends BaseResourceModel {
  constructor(
    public link?: string,
    public referencia?: string,
    public descricao?: string,
    public grupo?: TransparenciaInformacaoAdicionalGrupo,
  ) {
    super();
  }

  static converteJson(json: any): TransparenciaInformacaoAdicionalItem {
    return Object.assign(new TransparenciaInformacaoAdicionalItem(), json);
  }
}